// branding.ts — de ene naamgevings-naad (Fase 5.4 / plan-besluit D6).
//
// De tool generaliseert richting "projecten tekenen en rekenen, ook zonder
// laadpalen" (energie-modus). Sinds T5.1 dekt de naam die lading: de tool heet
// naar buiten toe Project Builder en woont op /project-builder. Codemappen
// (src/features/laadplein-designer) en tabellen (laadplein_design_*) houden
// bewust hun oude naam — die hernoemen kost een migratie zonder dat een
// gebruiker er iets van merkt.
//
// Alle UI-headers, breadcrumbs, PDF-doclabels en export-bestandsnamen horen
// déze constanten te gebruiken — een volgende rename is dan weer één file.

export const PRODUCT_NAME = 'Project Builder';

/** Mode-neutraal label voor documenten/exports ("Ontwerp" i.p.v. "Laadplein-ontwerp"). */
export const DOC_LABEL_ONTWERP = 'Ontwerp';
export const DOC_LABEL_RAPPORT = 'Projectrapport';

/** Basis voor export-bestandsnamen (was hardcoded 'laadplein'). */
export const EXPORT_FILE_BASE = 'ontwerp';
